import iconAddress from '../assets/icons/contact/icon-address.png'
import iconPhone from '../assets/icons/contact/icon-phone.png'
import iconEmail from '../assets/icons/contact/icon-email.png'
import socialFacebook from '../assets/icons/contact/social/facebook.png'
import socialX from '../assets/icons/contact/social/x.png'
import socialInstagram from '../assets/icons/contact/social/instagram.png'
import socialLinkedin from '../assets/icons/contact/social/linkedin.png'
import socialYoutube from '../assets/icons/contact/social/youtube.png'
import { contactInfo, socialLinks } from './navigation'

const socialUrl = (label) => socialLinks.find((link) => link.label === label)?.url ?? '#'

export const contactHero = {
  title: 'Got any questions?',
  subtitle:
    "Have questions about our programs? Want to volunteer or partner with us? We'd love to hear from you!",
}

export const contactInfoCards = [
  {
    title: 'Address',
    lines: [contactInfo.address],
    icon: iconAddress,
    iconBg: 'rgba(183, 7, 7, 0.12)',
  },
  {
    title: 'Phone',
    lines: [contactInfo.phone, contactInfo.phoneHours],
    icon: iconPhone,
    iconBg: 'rgba(183, 142, 7, 0.12)',
  },
  {
    title: 'Email',
    lines: [contactInfo.email, contactInfo.emailAlt],
    icon: iconEmail,
    iconBg: 'rgba(7, 183, 183, 0.12)',
  },
]

export const contactSubjectOptions = [
  'General Inquiry',
  'Volunteer With Us',
  'Partner With Us',
  'Program Information',
  'Event Registration',
  'Other',
]

export const contactSocialLinks = [
  {
    label: 'Facebook',
    url: socialUrl('Facebook'),
    icon: socialFacebook,
    bg: 'rgba(25, 119, 243, 0.12)',
    iconSx: { width: { xs: 48, md: 64, lg: 64 }, height: { xs: 48, md: 64, lg: 64 } },
  },
  {
    label: 'X',
    url: socialUrl('X'),
    icon: socialX,
    bg: 'rgba(0, 0, 0, 0.12)',
    iconSx: { width: { xs: 48, md: 64, lg: 64 }, height: { xs: 43, md: 58, lg: 72 } },
  },
  {
    label: 'Instagram',
    url: socialUrl('Instagram'),
    icon: socialInstagram,
    bg: 'rgba(158, 61, 154, 0.12)',
    iconSx: { width: { xs: 48, md: 64, lg: 64 }, height: { xs: 48, md: 64, lg: 64 } },
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/',
    icon: socialLinkedin,
    bg: 'rgba(0, 119, 183, 0.12)',
    iconSx: { width: { xs: 48, md: 64, lg: 64 }, height: { xs: 46, md: 61, lg: 76 } },
  },
  {
    label: 'YouTube',
    url: socialUrl('YouTube'),
    icon: socialYoutube,
    bg: 'rgba(255, 0, 0, 0.12)',
    iconSx: { width: { xs: 48, md: 64, lg: 64 }, height: { xs: 34, md: 45, lg: 56 } },
  },
]
